// During the spike, the app is just the test page. The real converter
// (src/features/convert) replaces this after the spike.
import { SpikePage } from '../features/spike/SpikePage';
import './base.css';

export function App() {
  return <SpikePage />;
}
